import { GET_AUDIT_ELIGIBILITY_URL } from "../../constants/apiUrls"
import { GET_AUDIT_ELIGIBILITY_QUERY_KEY } from "../../constants/queryKeys";
import axiosClient from "../axiosClient"
import { useCustomQuery } from "../utils/useCustomQuery";

export const useGetAuditEligibility = () => {
  const getAuditEligibility = async () => {
    const res = await axiosClient.get<string[]>(GET_AUDIT_ELIGIBILITY_URL);

    return res.data;
  }

  return useCustomQuery(GET_AUDIT_ELIGIBILITY_QUERY_KEY, getAuditEligibility);
}
